import { createApp, provide, ref } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { responseInterceptor } from './services/campaignService';
import eventBus from './event-bus';

responseInterceptor();

const app = createApp(App);
app.use(store).use(router);

const isLoading = ref(false);

eventBus.$on('show-loading', () => {
  if (!isLoading.value) {
    isLoading.value = true;
  }
});

eventBus.$on('hide-loading', () => {
  if (isLoading.value) {
    isLoading.value = false;
  }
});

app.config.unwrapInjectedRef = true; // Enable auto-unwrapping of ref

app.provide('isLoading', isLoading);

app.mount('#app');
